export default __webpack_public_path__ + "images/c806f001e433d79489f36589bdd74248-paypal.svg";